<template>
  <b-col>
    <BOverlay
      id="infinite-list"
      variant="light"
      :show="state.loading"
      spinner-variant="primary"
      blur="0"
      opacity=".5"
      rounded="sm"
    >
      <BTable
        :items="itemsForms"
        :fields="state.fields"
        hover
        show-empty
        empty-text="Belum ada list Forms"
        responsive
        class="mt-1"
      >
        <template #cell(no)="data">
          <div style="min-width: 10px !important">
            {{ data.index + 1 }}
          </div>
        </template>
        <template #cell(header)="data">
          <div
            class="d-flex items-center gap-5"
            style="min-width: 20px !important; "
          >
            <div><b-img
              :src="data.item.header"
              fluid
              style="width: 120px; height: 74px; object-fit: cover;"
            /></div>
          </div>
        </template>
        <template #cell(is_published)="data">
          <div style="min-width: 20px !important;">
            <b-badge
              v-if="data.item.is_published"
              pill
              style="background-color: #BEFCDE ; color:#34A770 ; width: -webkit-fill-available;"
              class="bg-[#BEFCDE] text-[#34A770]"
            >
              Aktif
            </b-badge>
            <b-badge
              v-else
              pill
              style="background-color: #FCBEBE ; color:#E31A1A ; width: -webkit-fill-available;"
              class="bg-[#FCBEBE] text-[#E31A1A]"
            >
              Tidak Aktif
            </b-badge>
          </div>

        </template>
        <template #cell(total_participant)="data">
          <div style="min-width: 20px !important">
            {{ data.item.total_participant || 0 }} / {{ data.item.max_participant || 0 }}
          </div>
        </template>
        <template #cell(created_at)="data">
          <div style="min-width: 20px !important">
            {{ DAY_MONTH_YEAR(data.item.created_at) }}
          </div>
        </template>
        <template #cell(url)="data">
          <div
            class="d-flex align-items-center"
            style="color: #08A0F7;"
          >
            {{ data.item.url }}
            <b-button
              variant="light"
              class="p-0"
              style="color: #08A0F7; margin-left: 4px;"
              @click.prevent="urlCopy(data.item.url)"
            >
              <b-img
                src="https://storage.googleapis.com/komerce/assets/copy.svg"
                style="filter: brightness(0) saturate(100%) invert(52%) sepia(76%) saturate(4949%) hue-rotate(185deg) brightness(101%) contrast(101%);"
              />
            </b-button>
          </div>
        </template>
        <template #cell(closing_statement)="data">
          {{ truncateText(data.value, 38) }}
        </template>
        <template #cell(action)="data">
          <div
            class="d-flex"
            style="gap: 1rem; min-width: 20px !important "
          >
            <div
              v-b-popover.hover.top="'Edit Form'"
              style="cursor: pointer;"
              @click.stop="editForm(data.item.id)"
            >
              <img
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/edit.svg"
                alt="logo-edit"
                class="w-full"
              >
            </div>
            <div
              v-b-popover.hover.top="'Delete Form'"
              v-b-modal.modal-delete-form
              style="cursor: pointer;"
              @click.stop="handleDelete(data.item.id)"
            >
              <img
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/trash.svg"
                alt="logo-eye"
                class="w-full"
              >
            </div>
            <div
              v-b-modal.modal-publish-form
              v-b-popover.hover.top="data.item.is_published ? 'Unpublish Form' : 'Publish Form'"
              style="cursor: pointer;"
              @click.stop="handlePublish(data.item.id)"
            >
              <img
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/global.svg"
                alt="logo-global"
                class="w-full"
                :class="{ 'unpublished-image': !data.item.is_published }"
              >
            </div>
          </div>
        </template>
      </BTable>
    </BOverlay>
    <modal-delete-form
      @submit="handleDeleteForm"
    />
    <modal-publish-form
      @submit="handlePublishForm"
    />
  </b-col>
</template>

<script>
import {
  reactive, onMounted, computed, ref,
} from '@vue/composition-api'
import router from '@/router'
import { useRouter } from '@/@core/utils/utils'
import { DAY_MONTH_YEAR } from '@/libs/filterDate'
import { newAxiosIns } from '@/libs/axios'
import {
  columnsTableForm, truncateText, toastSuccess, toastError,
} from '../config'

import modalDeleteForm from './ModalDeleteForm.vue'
import modalPublishForm from './ModalPublishForm.vue'

export default {
  name: 'TableForm',
  components: {
    modalDeleteForm,
    modalPublishForm,
  },
  props: {
    itemsForms: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const route = useRouter()
    const state = reactive({
      id: '',
      items: [],
      fields: columnsTableForm,
      loading: false,
    })

    const handleDelete = id => {
      state.id = id
    }

    const handlePublish = id => {
      state.id = id
    }

    function handleDeleteForm() {
      state.loading = true
      const url = `/komclass/api/v1/forms/${state.id}`
      newAxiosIns.delete(url)
        .then(res => {
          if (res.data.meta.code === 200) {
            toastSuccess('Data Berhasil Dihapus')
            this.$emit('data-table')
          } else {
            toastError(res.data.meta.message)
          }
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.error(err)
          // toastError('Gagal Menghapus Data')
          state.loading = false
        })
        .finally(() => {
          state.loading = false
        })
    }

    const handlePublishForm = () => {
      state.loading = true
      const url = `/komclass/api/v1/forms/${state.id}/publish-unpublish`
      newAxiosIns.patch(url)
        .then(res => {
          const { meta } = res.data
          if (meta.code === 200) {
            toastSuccess(meta.message)
            this.$emit('data-table')
          } else {
            toastError(meta.message)
          }
        })
        .catch(() => {
          state.loading = false
        })
        .finally(() => {
          state.loading = false
        })
    }

    const urlCopy = url => {
      navigator.clipboard.writeText(url)
      toastSuccess('URL berhasil di copy')
    }

    const editForm = data => {
      router.push({
        name: 'data-event-form-edit',
        params: { id: data },
      })
    }

    return {
      state,
      truncateText,
      DAY_MONTH_YEAR,
      route,
      handleDeleteForm,
      handlePublishForm,
      urlCopy,
      editForm,
      handleDelete,
      handlePublish,
    }
  },
}
</script>

<style scoped>
.unpublished-image {
  opacity: 0.5;
}
</style>
